import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { onApiCall } from '../../../../common/store/generic.reducer';
import { GenericState, IState } from '../../../../common/store/types';
import { ListItem } from '../../typeahead/types';
import { AttendanceRegularityModel } from './types';
import { userWorkAttendanceActions } from './user-work-attendance.actions';

export interface IUserWorkAttendanceState
  extends IState<AttendanceRegularityModel> {
  getRegularity: GenericState<AttendanceRegularityModel>;
  getUsers: GenericState<ListItem[]>;
  getSalesPersonRegularity: GenericState<AttendanceRegularityModel>;
  getSalesPersonUsers: GenericState<ListItem[]>;
}

export const userWorkAttendanceInitialState: IUserWorkAttendanceState = {
  getRegularity: new GenericState<AttendanceRegularityModel>(),
  getUsers: new GenericState<ListItem[]>(),
  getSalesPersonRegularity: new GenericState<AttendanceRegularityModel>(),
  getSalesPersonUsers: new GenericState<ListItem[]>(),
};

const userWorkAttendanceReducers = [
  ...onApiCall<AttendanceRegularityModel>(
    userWorkAttendanceActions.getRegularity,
    'getRegularity',
  ),
  ...onApiCall<ListItem[]>(userWorkAttendanceActions.getUsers, 'getUsers'),
  ...onApiCall<AttendanceRegularityModel>(
    userWorkAttendanceActions.getSalesPersonRegularity,
    'getSalesPersonRegularity',
  ),
  ...onApiCall<ListItem[]>(
    userWorkAttendanceActions.getSalesPersonUsers,
    'getSalesPersonUsers',
  ),
];

export const userWorkAttendanceReducer = createReducer(
  userWorkAttendanceInitialState,
  ...userWorkAttendanceReducers,
) as ActionReducer<IUserWorkAttendanceState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return userWorkAttendanceReducer(state, action);
}
